module.exports = __webpack_public_path__ + "img/root100.567c76e0.png";